<div class="head">
  <p class="bold">{{ 'mercer-support.dialog.pc-for-comparison' | translate }}</p>
</div>
<div class="filter">
  <p>{{ 'mercer-support.dialog.apply-filter' | translate }}</p>
  <div class="inputs">
    <coin-v2-dropdown
      #searched="dropdownSearch"
      required
      [placeholder]="'general.click-to-select' | translate"
      [dataSource]="'OrgLevel' | pure: lazyLoadFn()"
      [label]="'mercer-support.dialog.org-level' | translate"
      [disabled]="isReadOnly()"
      [(ngModel)]="selectedOrgLevel"
      (ngModelChange)="updateRelatedPositions.emit()">
      @for (option of searched.results() | sortAlphabetically; track option) {
        <ng-template [coinValue]="option">{{ option }}</ng-template>
      }
    </coin-v2-dropdown>
    <coin-v2-text-input
      [label]="'mercer-support.dialog.org-code' | translate"
      [disabled]="isReadOnly() || isLocked()"
      [(ngModel)]="selectedOrgCode"
      (ngModelChange)="updateRelatedPositions.emit()" />
  </div>
</div>
<div class="position-list">
  @for (position of relatedPositions(); track position) {
    <div
      class="item"
      (click)="openPosition.emit(position)">
      <div class="first-line">
        <p class="bold">{{ position?.positionName }}</p>
        @if (!!position?.newPositionClass) {
          <p class="position-class bold">PC {{ position?.newPositionClass }}</p>
        }
        @if (!position?.newPositionClass) {
          <p class="position-class missing bold">{{ 'mercer-support.dialog.no-pc' | translate }}</p>
        }
      </div>
      <div class="second-line">
        <p>{{ position?.orgCode }}</p>
        @if (!!position?.incumbent) {
          <p>{{ $safeNavigationMigration(position?.incumbent) | employeeName }}</p>
        }
        @if (!position?.incumbent) {
          <p>{{ 'mercer-support.dialog.no-incumbent' | translate }}</p>
        }
      </div>
    </div>
  }
  @if (!relatedPositions()?.length) {
    <p>{{ 'mercer-support.dialog.no-positions' | translate }}</p>
  }
</div>
